import React, { Component } from 'react';
import { Divider } from 'semantic-ui-react';
// import ContactSupport from './ContactSupport';

class Sharing extends Component {
	render() {
		return(
			<div style={{marginTop: '10px'}} className="animated fadetwoIn flex-container flex-column">
				<h1 style={{textAlign: 'center'}}>Sharing</h1>
				<p style={{textAlign: 'center'}}>
					Welcome to the Sharing page! <br />
					Being Established
				</p>
				<Divider />
			</div>
		);
	}
}

export default Sharing;
